module.exports = __webpack_public_path__ + "img/second-plate.ecf35f92.png";